import { screenBrand } from "./brand";

/**
 * 画面の配色を上書きする CSS を組み立てる。
 *
 * 配色は[ブランド](/domain/management/company-auth/tenant/glossary.md#Brand)の一部であり、
 * 画面のテナントから定まる（spec `oem-login`）。既定テナントとブランドを解決できないテナント
 * では上書きしない（既定の見た目をそのまま使う）。
 */
export const brandThemeCss = (): string | null => {
  const brand = screenBrand();
  if (brand.unresolved) {
    return null;
  }
  const color = brand.buttonColor;
  if (color === null || !isSafeColor(color)) {
    return null;
  }
  return `:root{--element-link-primary:${color};}`;
};

/**
 * 色として解釈できる値かを判定する。
 *
 * 設定値をそのままスタイルシートに埋めるため、色以外の文字列（宣言を閉じて別の規則を足す等）を
 * 弾く。判定に通らない値は使わず、既定の配色に落とす。
 */
export const isSafeColor = (value: string): boolean =>
  /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(value);
